"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetVariablesStyle = void 0;
var firstPartVariables = {
    "$tpd-font-size": "16px",
    $bold: "\"Unipol Bold\"",
    $medium: "\"Unipol Medium\"",
    $normal: "\"Unipol\"",
    $white: "#fff",
    $ivory: "#f1f1f1",
    $white_smoke: "#f7f7f7",
    $dirty_white: "#fefefe",
    $main_color: "#0f3250",
    $dark_blue: "#183a56",
    $medium_blue: "#4886ae",
    "$medium-light-blue": "#5393bc",
    "$very-light-blue": "#e0eef7",
    "$dark-light_blue": "#0f3250",
    "$text-blue": "#0f3250",
    $dot_slick_bg: "#d8d8d8",
    $tab_heading: "#142f45",
    $grey_border_form: "#c1c1c1",
    "$dark-grey": "#afafaf",
    "$soft-grey": "#f0f0f0",
    "$title-blue": "#627482",
    "$gradient-light-blue": "#255f90",
    $main_red: "#c4151c",
    $main_red_hover: "#920c11",
    $error_red: "#ff001f",
    $light_red: "#edb8ba",
    $grey: "#9b9b9b",
    $Tgrey: "#4a4a4a",
    $light_grey: "#666666",
    "$middle-grey-pu": "#5c5c5c",
    $grey_accordion_btn: "#979797",
    $grey_border: "#d6d6d6",
    $blue: "#308992",
    $green: "#629419",
    $yellow: "#d79b00",
    $orange: "#c35619",
    $purple: "#812d5a",
    $black: "#000000",
    $light_blue: "#e2f0f9",
    $lighter_blue: "#f0f8fc",
    $green_light: "#dcf3b9",
    $yellow_light: "#fff6de",
    $purple_light: "#d6b8c9",
    $orange_light: "#ffbc7f",
    $blue_medium: "#a8c4d6",
    $green_medium: "#aed770",
    $green_gmap: "#6fba33",
    $green_success: "#38c661",
    "$screen-lg-min": "1281px",
    "$screen-md-min": "769px",
    "$screen-sm-min": "0px",
    "$screen-xs-max-320": "320px",
    "$screen-xs-max-400": "400px",
    "$mobile-min-width": "320px",
    "$mobile-max-width": "768px",
    "$tablet-min-width": "769px",
    "$tablet-max-width": "1279px",
    $bkp_smartphone_only: "\"only screen and (max-width: 690px)\"",
    "$grid-gutter-width": "8px !default",
    "$container-mobile": "(767px) !default",
    "$container-tablet": "(1279px) !default",
    "$container-desktop": "(1280px) !default",
    "$container-large-desktop": "(1280px) !default",
    $mostard: "#e0aa00",
    "$input-label-height": "30px",
    "$color-blue-medium": "#3e759b",
    "$color-azure-light": "#cce3f9",
    "$color-green": "#8bc94d",
    "$color-orange": "#ff9000",
    "$light-blue-color": "#6bd1ff",
    $very_dark_blue: "#050e16",
    "$property-color": "#e94e10",
    $grigio: "#ccc",
    "$car-color": "#0169b4",
    "$house-color": "#ea4d10",
    "$famiglia-color": "#ea4d10",
    "$salute-color": "#59a627",
    "$mobility-color": "#0169b4",
    "$viaggi-color": "#ea4d10",
    "$pet-color": "#ea4d10",
    "$infortuni-color": "#59a627",
    $space_cadet: "#193a56",
    $body_color: "#333",
};
var secondPartVariables = {
    $unipol_error: firstPartVariables["$error_red"],
    $placeholder_color: firstPartVariables["$light_grey"],
    $mobilty_blue: firstPartVariables["$blue"],
    $home_green: firstPartVariables["$green"],
    $work_yellow: firstPartVariables["$yellow"],
    $protection_orange: firstPartVariables["$orange"],
    $saving_purple: firstPartVariables["$purple"],
    $bkp_mobile: "only screen and (min-width: ".concat(firstPartVariables["$screen-sm-min"], ")"),
    $bkp_tablet: "only screen and (min-width: ".concat(firstPartVariables["$screen-md-min"], ")"),
    $bkp_desktop: "only screen and (min-width: ".concat(firstPartVariables["$screen-lg-min"], ")"),
    $bkp_mobile_only: "only screen and (max-width: ".concat(firstPartVariables["$mobile-max-width"], ")"),
    $bkp_tablet_only: "only screen and (min-width: ".concat(firstPartVariables["$tablet-min-width"], ") and (max-width: ").concat(firstPartVariables["$tablet-max-width"], ")"),
    $bkp_320_only: "only screen and (max-width: ".concat(firstPartVariables["$screen-xs-max-320"], ")"),
    $bkp_400_only: "only screen and (max-width: ".concat(firstPartVariables["$screen-xs-max-400"], ")"),
};
exports.widgetVariablesStyle = __assign(__assign({}, firstPartVariables), secondPartVariables);
